const vendas = angular.module('vendas', [])

vendas.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'admin.vendas',
            url: '/vendas',
            params: { showGlobalLoading: { dynamic: true, value: false } },
            component: 'vendas.vendasComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);